import _ from 'lodash'
import '../scss/app.scss'
import 'animate.css'
import 'normalize.css'

/* var Flickity = require('flickity')
import 'flickity/dist/flickity.css' */

// import Swiper JS
// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle'

// import Swiper and modules styles
import 'swiper/css/bundle'

jQuery(function ($) {
	/* 	if ($('.podcast-carousel-slider').length > 0) {
		var flkty = new Flickity('.podcast-carousel-slider', {
			setGallerySize: false,
			pageDots: false,
			draggable: true,
		})
	} */

	const swiper = new Swiper('.podcast-carousel-container', {
		loop: false,
		speed: 1000,
		autoplay: {
			delay: 3000,
		},
		effect: 'coverflow',
		grabCursor: false,
		initialSlide: 1,
		centeredSlides: true,
		slidesPerView: 'auto',
		coverflowEffect: {
			rotate: 0,
			stretch: 80,
			depth: 200,
			modifier: 1,
			slideShadows: false,
		},
	})

	/****************** HAMBURGUES MENU ******************/

	$('#masthead').on('click', 'button', function () {
		$(this).toggleClass('is-active')
		$('#page.site').toggleClass('menu-open')
		$('body').toggleClass('is--open')
	})

	$('.gform_footer .gform_button').prop('disabled', true)

	if ($('.ginput_container_email input').val().length > 0) {
		$('.gform_footer .gform_button').prop('disabled', false)
	}

	/****************** CHECK EMAIL FIELD ******************/

	$('.ginput_container_email input').on('input', function () {
		if ($('.ginput_container_email input').val().length > 0) {
			$('.gform_footer .gform_button').prop('disabled', false)
		} else {
			$('.gform_footer .gform_button').prop('disabled', true)
		}
	})

	/****************** STICKY NAV ******************/

	$(window).on('scroll', function () {
		const positHeight =
			$(document).scrollTop() -
			($('.horizontal-menu').offset().top +
				$('.horizontal-menu').outerHeight())
		const scrollPos = $(this).scrollTop()

		setTimeout(function () {
			$('div').removeClass('active-is')
		}, 4000)

		var $menuBarHeight = $('.horizontal-menu').outerHeight()
		if (windowWidth < 1024) {
			$menuBarHeight = $('.horizontal-menu').height()
		}

		$('.horizontal-menu').height($menuBarHeight)

		if (scrollPos >= menuBarPos - $headerMenu.outerHeight()) {
			$menuBar.addClass('sticky_bar')
		} else {
			$menuBar.removeClass('sticky_bar')
		}
	})
})
